import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  getClasses,
  getAssignedStudents,
  assignStudentsToClass,
  addClass,
  updateClass,
  deleteClass,
  getClassById,
  getClassesByInstance,
} from "../../../../services/classService";
import { getStudents } from "../../../../services/studentService";
import { getSubjects } from "../../../../services/subjectService";
import { Modal, message } from "antd";
import { ClassData, StudentData } from "../../../../types/classTypes";
import { Subject } from "../../../../types/subjectTypes";
import { getClassLevels } from "../../../../services/feeTypeService";
import { assignTeacherToClass } from "services/classSubjectService";

const useClassManagement = () => {
  const { t } = useTranslation();

  const [classes, setClasses] = useState<ClassData[]>([]);
  const [classesIntance, setClassesInstance] = useState<ClassData[]>([]);

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });
  const [assignedStudents, setAssignedStudents] = useState<StudentData[]>([]);
  const [allStudents, setAllStudents] = useState<StudentData[]>([]);
  const [selectedStudents, setSelectedStudents] = useState<StudentData[]>([]);
  const [currentClassId, setCurrentClassId] = useState<string | null>(null);
  const [isAssignModalOpen, setAssignModalOpen] = useState(false);
  const [isAddEditModalOpen, setAddEditModalOpen] = useState(false);
  const [editingClass, setEditingClass] = useState<ClassData | null>(null);
  const [subjects, setSubjects] = useState<Subject[]>([]);
  const [classLevels, setClassLevels] = useState<any[]>([]);
  const [detailClass, setDetailClass] = useState<ClassData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    // fetchClasses();
    fetchAllStudents();
    fetchSubjects();
  }, []);

  const fetchClasses = async () => {
    setLoading(false);
    try {
      const response = await getClasses();
      setClasses(response);
      setLoading(false);
    } catch (error) {
      message.error(t("failed_to_fetch_classes"));
    } finally {
      setLoading(false);
    }
  };


  const fetchClassesWithPagination = async (parames: any) => {
    setLoading(true);
    try {
      const response = await getClassesByInstance(parames);
      setClassesInstance(response.data);
      setPagination(response.pagination);
      setLoading(false);
    } catch (error) {
      message.error(t("failed_to_fetch_classes"));
    } finally {
      setLoading(false);
    }
  };

  const fetchAllStudents = async () => {
    try {
      const response = await getStudents({ page: 1, limit: 100000 });
      setAllStudents(response.data);
    } catch (error) {
      message.error(t("failed_to_fetch_students"));
    }
  };

  const openAssignModal = async (classId: string) => {
    setCurrentClassId(classId);
    try {
      const response = await getAssignedStudents(classId);
      setAssignedStudents(response);
      setSelectedStudents(response);
      setAssignModalOpen(true);
    } catch (error) {
      message.error(t("failed_to_fetch_assigned_students"));
    }
  };

  const handleGetAssignedStudents = async (classId: string) => {
    try {
      const response = await getAssignedStudents(classId);
      setAssignedStudents(response);
    } catch (error) {
      message.error(t("failed_to_fetch_assigned_students"));
    }
  };

  const openAddEditModal = (classData?: ClassData) => {
    setEditingClass(classData || null);
    console.log(classData);
    setAddEditModalOpen(true);
  };

  const handleAssignStudentsSave = async (classId: string, students: StudentData[]) => {
    if (!classId) {
      message.error(t("invalid_class_id"));
      return;
    }
    try {
      await assignStudentsToClass(classId, students.map((s) => s.id));
      message.success(t("students_assigned_successfully"));
      setAssignModalOpen(false);
      // fetchClasses();
      return true;
    } catch (error) {
      message.error(t("failed_to_assign_students"));
      return false;
    }
  };
  const handleDeleteClass = async (classId: string) => {
    try {
      await deleteClass(classId);
      message.success(t("class_deleted_successfully"));
      return true;
    } catch (error) {
      message.error(t("failed_to_delete_class"));
      return false;
    }
  };

  const handleSaveClass = async (classData: Partial<ClassData>) => {
    try {
      if (classData.id) {
        await updateClass(classData.id, classData);
        message.success(t("class_updated_successfully"));
      } else {
        await addClass({
          ...classData,
          classSubjectCoefficient: classData.classSubjectCoefficient || []
        });
        message.success(t("class_added_successfully"));
      }
      // fetchClasses();
      setAddEditModalOpen(false);
      return true;
    } catch (error) {
      message.error(t("failed_to_save_class"));
      return false
    }
  };
  const fetchSubjects = async () => {
    try {
      const response = await getSubjects();
      setSubjects(response);
    } catch (error) {
      message.error(t("failed_to_fetch_subjects"));
    }
  };
  const fetchClassLevels = async () => {
    try {
      const response = await getClassLevels();
      setClassLevels(response.data);
    } catch (error) {
      message.error(t("failed_to_fetch_class_levels"));
    }
  };
  const handleGetClassById = async (classId: string) => {
    try {
      const response = await getClassById(classId);
      setDetailClass(response);
    } catch (error) {
      message.error(t("failed_to_fetch_class"));
    }
  };

  const handleAssignTeacherToClass = async (classSubjectId: string, teacherId: string) => {
    try {
      await assignTeacherToClass({ classSubjectId, teacherId });
      message.success(t("teacher_assigned_successfully"));
    } catch (error) {
      message.error(t("failed_to_assign_teacher"));
    }
  };
  return {
    classes,
    subjects,
    assignedStudents,
    allStudents,
    selectedStudents,
    currentClassId,
    isAssignModalOpen,
    isAddEditModalOpen,
    editingClass,
    openAssignModal,
    openAddEditModal,
    handleAssignStudentsSave,
    handleSaveClass,
    handleDeleteClass,
    setAssignModalOpen,
    setAddEditModalOpen,
    classLevels,
    fetchClassLevels,
    handleGetClassById,
    detailClass,
    handleGetAssignedStudents,
    handleAssignTeacherToClass,
    loading,
    fetchClassesWithPagination,
    pagination,
    classesIntance,
    fetchClasses
  };
};

export default useClassManagement;
